import rest from "@/rest-client";
import createCrudVuexModule from "@/store/crud";
const path = "/finding";
export const organizationFinding = createCrudVuexModule({
  namespaced: true,
  path: path,
  moduleName: "organizationFinding",
  options: {
    localizedFields: [
      "name",
      "description",
      "type",
      // "subSource",
      "rootCauses",
      "regulationRelation",
      "suggestions",
      "auditorRecommendations",
      "level",
      "category",
      "risk",
      // "criticality",
      "manager",
      "approver",
      "closureNote",
      "closureDuration",
      "closureApprover",
      "detectingPerson",
      "reporterNote",
    ],
  },
  state: {
    showFilterSidebar: false,
    findingFilters: {},
    activeTab: "ORGANIZATION_FINDINGS",
    activeSubTab: "EVALUATION_PENDING",
    lastListClass: null,
  },
  getters: {
    showFilterSidebar: (state) => state.showFilterSidebar,
    findingFilters: (state) => state.findingFilters,
    activeTab: (state) => state.activeTab,
    activeSubTab: (state) => state.activeSubTab,
    lastListClass: (state) => state.lastListClass,
  },
  mutations: {
    showFilterSidebar: (state, value) => {
      if (state.showFilterSidebar !== value) {
        state.showFilterSidebar = value;
        state.findingFilters = {
          no: "",
          name: "",
          category: null,
          type: null,
          class: undefined,
          status: undefined,
          compliance: "",
          complianceGroup: null,
          complianceItemNo: null,
          complianceItemSearch: "",
          complianceItemDescription: "",
        };
      }
    },
    findingFilters: (state, payload) => (state.findingFilters = payload),
    activeTab: (state, value) => (state.activeTab = value),
    activeSubTab: (state, value) => (state.activeSubTab = value),
    lastListClass: (state, value) => (state.lastListClass = value),
  },
  actions: {
    async requestApproval(context, payload) {
      return await rest.post(`${path}/request-approval`, payload);
    },
    async saveApproval(context, payload) {
      return await rest.post(`${path}/save-approval`, payload);
    },
    async cancel(context, payload) {
      return await rest.post(`${path}/cancel`, payload);
    },
    async fetchFilteredFindings({ commit }, payload) {
      const response = await rest.post(`${path}/detailed-paginate`, { pagination: payload });
      commit("pagination", response.data);
      return response;
    },
  },
});
